import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=54500a2a"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54500a2a')) {
      api.createRecord('54500a2a', component.options)
    } else {
      api.reload('54500a2a', component.options)
    }
    module.hot.accept("./TextEditor.vue?vue&type=template&id=54500a2a", function () {
      api.rerender('54500a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextEditor.vue"
export default component.exports